import { TAvailableConfigValues } from '@customTypes/common';

export interface IInsufficientBufferEstimatorConfig {
  minimalBufferAmount: number;
  ignoreMetricsBeforeBufferExceedsMinimal: boolean;
  switchToMinimalResolution: boolean;
}

export const defaultInsufficientBufferEstimatorConfig: IInsufficientBufferEstimatorConfig = {
  minimalBufferAmount: 0.1,
  ignoreMetricsBeforeBufferExceedsMinimal: true,
  switchToMinimalResolution: false,
};

export const availableInsufficientBufferEstimatorConfigValues: TAvailableConfigValues<IInsufficientBufferEstimatorConfig> = {};
